module.exports = __webpack_public_path__ + "static/media/ic_seats_b.70d91ab8.png";